export default "__VITE_ASSET__kxsCPWTi__"